import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/atoms'
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@/components/atoms/modal'
import { MiwaAppWebsocketContext } from '@/contexts/miwa-app-websocket'
import { TMiwaAppWebsocketContext } from '@/models/miwa-lock'
import { MiwaPcidInput } from './miwa-pcid-input'
import { centeredModalStyle, modalFooterRightStyle } from './card-key-modal-style'

type Props = {
  onClose: () => void
}

export const CardKeyConnectModal: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()
  const { connect, isLoadingFetchConnectionInfo, isMiwaAppConnected } = useContext<TMiwaAppWebsocketContext>(MiwaAppWebsocketContext)

  const onClickConnect = async () => {
    // PCID 未入力のときは入力できるよう開いたままにする。接続失敗時のアラートは fetchConnectionInfo 内で出すため、
    // 接続を試みた後は結果によらず閉じ、ヘッダーの接続状態で結果を示す
    if (await connect()) onClose()
  }

  return (
    <Modal customCss={centeredModalStyle(600)}>
      <ModalHeader>{t('Card key issuance at front desk')}</ModalHeader>
      <ModalBody>
        {isMiwaAppConnected ? (
          <p css={descriptionStyle}>{t('Connect websocket success')}</p>
        ) : (
          <>
            <p css={descriptionStyle}>{t('Please connect while aipass MIWA App is running.')}</p>
            <div css={inputBlockStyle}>
              <MiwaPcidInput id="cardKeyPcId" />
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <div css={modalFooterRightStyle}>
          {isMiwaAppConnected ? (
            <Button width={110} height={38} buttonType={3} onClick={onClose}>
              {t('Close')}
            </Button>
          ) : (
            <>
              <Button width={110} height={38} buttonType={3} marginRight={16} onClick={onClose}>
                {t('Cancel')}
              </Button>
              <Button
                width={110}
                height={38}
                buttonType={isLoadingFetchConnectionInfo ? 5 : 1}
                isDisabled={isLoadingFetchConnectionInfo}
                onClick={onClickConnect}
              >
                {t('Connect')}
              </Button>
            </>
          )}
        </div>
      </ModalFooter>
    </Modal>
  )
}

const descriptionStyle = css({
  color: '#676767',
  fontSize: 14,
  fontWeight: 'bold',
  letterSpacing: 0.7,
  marginBottom: 16,
})

const inputBlockStyle = css({
  backgroundColor: '#fff',
  padding: 24,
})
